// extracted by mini-css-extract-plugin
module.exports = {"type":"styles_type__2cLvp","type_btn":"styles_type_btn__3hGlK","list":"styles_list__yW_yx","item":"styles_item__3Bzgf"};